var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMotif21(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 31.9907,
    height: 16,
    viewBox: "0 0 31.9907 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 166"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.9953 0C24.8292 3.86142e-07 31.9907 7.16344 31.9907 16L15.9953 16L15.9953 0Z",
    fill: "#508FCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M-1.13016e-07 16C2.73242e-07 7.16344 7.16144 3.13036e-07 15.9953 6.99178e-07L15.9953 16L-1.13016e-07 16Z",
    fill: "#86905B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.8322 16C7.8322 11.4903 11.4869 7.83448 15.9953 7.83448L15.9953 16L7.8322 16Z",
    fill: "#274766"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotif21);
export default __webpack_public_path__ + "static/media/motif-21.b103c353425efb4cc6abc0fba618dd4b.svg";
export { ForwardRef as ReactComponent };